import {
  EMPTY_STATE_HEIGHT,
  EMPTY_STATE_PADDING,
  EMPTY_STATE_POSITION,
  EMPTY_STATE_WIDTH,
} from './consts'

export const getEmptyStateBounds = () => {
  const pad = EMPTY_STATE_PADDING
  return {
    minX: EMPTY_STATE_POSITION.x - pad,
    minY: EMPTY_STATE_POSITION.y - pad,
    maxX: EMPTY_STATE_POSITION.x + EMPTY_STATE_WIDTH + pad,
    maxY: EMPTY_STATE_POSITION.y + EMPTY_STATE_HEIGHT + pad,
  }
}
